import { useMemo } from 'react'
import { useNavigate, useLocation, useParams as useRrParams, useSearchParams as useRrSearchParams } from 'react-router-dom'

export function useRouter() {
  const navigate = useNavigate()
  return useMemo(() => ({
    push: (href: string, _options?: any) => navigate(href),
    replace: (href: string, _options?: any) => navigate(href, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
    prefetch: () => {},
  }), [navigate])
}

export function usePathname() {
  const { pathname } = useLocation()
  return pathname
}

export function useParams() {
  return useRrParams()
}

export function useSearchParams() {
  const [searchParams] = useRrSearchParams()
  return useMemo(() => searchParams, [searchParams.toString()])
}

export function notFound() {
  throw new Error('404 Not Found')
}
